import { showFullScreenLoading, tryHideFullScreenLoading } from "@/config/serviceLoading";
/**
 * 可处理多跨域
 * 每个请求可以有生命周期
 * 自定义loading
 * 复杂处理token数据
 */
import transformDataFn from "./transformData";
import { APIConfig, APIConfigData } from "@/api/interface";
export default function (axiosIns: any, config: APIConfig) {
  const obj: APIConfigData = {};
  // 在设计公共库的时候;能给默认值就给默认值
  // 所有的请求函数使用的corsUrl闭包是相同的!!!
  const { api = {} } = config;
  for (const key in api) {
    // 每一个请求函数都拥有一个唯一的corsUrlCopy闭包
    // let corsUrlCopy = corsUrl
    // isForm:请求体是否要使用formdata的形式
    let {
      url = "", // 每一个请求函数都拥有一个唯一的url闭包
      method = "get",
      // data: configData = {},
      dataType = "JSON",
      // loading: loadingObj = {},
      responseType = ""
      // hooks: { beforeReq, afterReqSuccess, afterReqFail }
    } = api[key];
    // 所有模块对应的请求函数!!!!!
    // 请求函数得返回promise 这个promise应该与axios返回的promise 处于同等状态 持有同等的值
    obj[key] = async function (data?: any, options?: any) {
      // 改变url
      // 通过parmas 传递参数
      if (options?.url) {
        const { url: optionsUrl } = options as any;
        url = optionsUrl;
      }
      let loadingFlag = false;
      if (options?.loading) {
        const { loading } = options as any;
        loadingFlag = loading;
      }
      // data外部逻辑传入的参数(请求数据);根据请求方法的不一样 将data塞到不一样的axios配置中
      // 将外部逻辑传入的参数(请求数据)  和 配置项中传入的参数合并起来
      // 并且外部逻辑传入的参数(请求数据)优先级要高!

      // data = Object.assign({}, configData, data)
      const transformData = transformDataFn(data, dataType);
      // 实现请求数据类型的转换

      // 请求得到的数据
      let body: any;
      // 真正发送请求的位置
      try {
        // 处理跨域  这一段逻辑只能执行一次
        // if (corsUrlCopy) {
        //   url = corsUrlCopy + url
        //   corsUrlCopy = '' // 会解决处理跨域被执行多次的问题
        // }

        // 处理token
        // const headers = {}
        // if (typeof token === 'function') {
        //   const tokenStr = token()
        //   if (tokenStr) {
        //     headers.Authorization = tokenStr
        //   }
        // }

        const headers: any = {};
        dataType === "JSON" ? (headers["Content-Type"] = "application/json; charset=utf-8") : undefined;

        // 请求前 开启loading
        loadingFlag && showFullScreenLoading();

        // typeof beforeReq === "function" && beforeReq.call(api[key]);
        switch (method.toLowerCase()) {
          case "get":
          case "delete":
            // 获取对应的axios实例 发送请求
            body = await axiosIns({
              url,
              method,
              params: transformData,
              responseType // query数据
            });
            break;

          case "put":
          case "post":
          case "patch":
            // 获取对应的axios实例 发送请求
            body = await axiosIns({
              url,
              method,
              data: transformData, // body数据
              responseType,
              headers
            });
            break;
        }
        // 请求后 请求已经成功
        loadingFlag && tryHideFullScreenLoading();
        // typeof afterReqSuccess === "function" && afterReqSuccess.call(api[key], body.data);
      } catch (e) {
        // 请求后 请求失败
        loadingFlag && tryHideFullScreenLoading();
        // typeof afterReqFail === "function" && afterReqFail.call(api[key], e);
        return Promise.reject(e);
      }
      // body 会变成当前请求函数返回的promise所持有的值
      return body;
    };
  }

  return obj;
}
